import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { ArrowBackIcon, CheckCircleIcon, ViewIcon, ViewOffIcon, WarningIcon } from '@chakra-ui/icons'
import { Box, Button, Flex, FormControl, Heading, Image, Input, InputGroup, InputRightElement, List, ListIcon, ListItem, Stack, Text, useMediaQuery, VStack } from '@chakra-ui/react'
import SessionStartLogo from '../../components/SessionStartLogo'
import { validateKeyUpPassword, validatePassword } from '../../utils/functionsValidateRegister'
import useAuth from '../../hooks/useAuth'
import clientAxios from '../../config/axios'

const quilmesImages = require.context('../../assets/images', true)

const PasswordRecovery = () => {
  const { oobCode } = useAuth()
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [isLargerThan1280] = useMediaQuery('(min-width: 1367px)')
  const [show, setShow] = useState(false)
  const [showRepeat, setShowRepeat] = useState(false)
  const [password, setPassword] = useState({
    pass: '',
    repeatPassword: ''
  })
  const [error, setError] = useState('')
  const [errorPassword, setErrorPassword] = useState('')
  const [errorRepeatPassword, setErrorRepeatPassword] = useState('')
  const [checks, setChecks] = useState({
    lowercase: false,
    uppercase: false,
    length: false,
    number: false,
    space: false
  })
  const handleClick = () => setShow(!show)
  const handleClickRepeat = () => setShowRepeat(!showRepeat)
  const navigate = useNavigate()

  useEffect(() => {
    if (!oobCode) {
      navigate('/')
    }
  }, [])

  const handleOnBlurPassword = () => {
    if (password.pass === '') {
      setErrorPassword('')

      return
    }
    if (
      !checks.lowercase ||
      !checks.uppercase ||
      !checks.length ||
      !checks.number
    ) {
      setErrorPassword('La contraseña no cumple con los requisitos.')
    }
  }

  const handleOnKeyUpPassword = (e) => {
    const { value } = e.target

    if (
      checks.lowercase ||
      checks.uppercase ||
      checks.length ||
      checks.number || checks.space
    ) {
      setErrorPassword('')
    }

    setChecks(validateKeyUpPassword(value))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const error = validatePassword(password)

    if (error.pass) {
      setErrorPassword(error.pass)

      return
    }

    if (error.repeatPassword) {
      setErrorRepeatPassword(error.repeatPassword)

      return
    }

    // si password y repeatPassword no son iguales lanzar error
    if (password.pass !== password.repeatPassword) {
      setError('Las contraseñas no coinciden. Asegurate que sean iguales e intentalo nuevamente.')
      setErrorPassword(true)
      setErrorRepeatPassword(true)

      return
    }

    if (error.pass || error.repeatPassword) {
      return
    }

    clientAxios.post('/auth/changePassword', { oobCode, newPassword: password.pass })

    navigate('/success-recovery')
  }

  const handleFocusError = () => {
    setError('')
    setErrorPassword('')
    setErrorRepeatPassword('')
  }

  return (
    <Box
      className='boxInvited'
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box bg='white' mx={'auto'}>
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          padding={'3rem 1rem 2rem 1rem'}
          w={{ base: '100%', md: '100%' }}
          onSubmit={handleSubmit}
          {...(isLargerThan1280
            ? { paddingTop: '12rem' }
            : isLargerThan768
              ? { paddingTop: '3rem' }
              : {})}
        >
          <SessionStartLogo />
          <Link to={'/'}>
            <ArrowBackIcon color={'#0A0808'} h={6} marginTop={{ base: 6, md: 4 }} w={6} />
          </Link>
          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'2rem'}>
            Recuperar contraseña
          </Heading>
          <Text fontSize={'0.8rem'} fontWeight={'400'}>
            Ingresá una nueva contraseña para tu cuenta.
          </Text>

          <Stack paddingTop={'1rem'} w={{ base: '100%', md: 400 }}>
            <FormControl
              className='floating-label-group'
              onFocus={handleFocusError}
            >
              <InputGroup>
                <Input
                  className='input'
                  id='password'
                  name='password'
                  placeholder=' '
                  type={show ? 'text' : 'password'}
                  value={password.pass}
                  onBlur={handleOnBlurPassword}
                  onChange={(e) => setPassword({ ...password, pass: e.target.value })}
                  onFocus={() => setErrorPassword('')}
                  onKeyUp={handleOnKeyUpPassword}
                  {...(errorPassword !== '' ? { borderColor: 'red.500' } : {})}
                  _hover={{
                    ...(errorPassword !== '' ? { borderColor: 'red.500' } : {})
                  }}
                />
                <label
                  className='placeholder'
                  htmlFor='password'
                  {...(errorPassword !== ''
                    ? { className: 'error-input' }
                    : {})}
                >
                  Contraseña
                </label>
                <InputRightElement width='4.5rem'>
                  <Button
                    _active={{ background: 'none' }}
                    _focusVisible={{ boxShadow: 'none' }}
                    _hover={{ background: 'none' }}
                    arial-label='Mostrar contraseña'
                    background={'none'}
                    marginLeft={'1.5rem'}
                    onClick={handleClick}
                  >
                    {show
                      ? (
                        <ViewIcon color='blackAlpha.700' />
                      )
                      : (
                        <ViewOffIcon color='blackAlpha.500' />
                      )}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errorPassword && (
              <Text
                color='red.500'
                fontSize={'12px'}
                paddingLeft={'.5rem'}
                paddingTop={'.5rem'}
                w={{ base: '75%', md: 400 }}
              >
                {errorPassword}
              </Text>
              )}
            </FormControl>

            <FormControl
              className='floating-label-group'
              paddingTop={'.5rem'}
              onFocus={handleFocusError}
            >
              <InputGroup>
                <Input
                  className='input'
                  id='passwordRepeat'
                  name='passwordRepeat'
                  placeholder=' '
                  type={showRepeat ? 'text' : 'password'}
                  value={password.repeatPassword}
                  onChange={(e) => setPassword({ ...password, repeatPassword: e.target.value })}
                  onFocus={() => setErrorRepeatPassword('')}
                  {...(errorRepeatPassword !== '' ? { borderColor: 'red.500' } : {})}
                  _hover={{
                    ...(errorRepeatPassword !== '' ? { borderColor: 'red.500' } : {})
                  }}
                />
                <label
                  className='placeholder'
                  htmlFor='passwordRepeat'
                  {...(errorRepeatPassword !== ''
                    ? { className: 'error-input' }
                    : {})}
                >
                  Repetir contraseña
                </label>
                <InputRightElement width='4.5rem'>
                  <Button
                    _active={{ background: 'none' }}
                    _focusVisible={{ boxShadow: 'none' }}
                    _hover={{ background: 'none' }}
                    arial-label='Mostrar contraseña'
                    background={'none'}
                    marginLeft={'1.5rem'}
                    onClick={handleClickRepeat}
                  >
                    {showRepeat
                      ? (
                        <ViewIcon color='blackAlpha.700' />
                      )
                      : (
                        <ViewOffIcon color='blackAlpha.500' />
                      )}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errorRepeatPassword && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorRepeatPassword}
                </Text>
              )}
            </FormControl>

            {error && (
              <Box display={'flex'} gap={2}>
                <WarningIcon
                  bg={'red'}
                  border={'1px solid red'}
                  borderRadius={'50px'}
                  color={'#FFF'}
                />
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  marginTop={'-.5rem'}
                  w={'95%'}
                >
                  {error}
                </Text>
              </Box>
            )}
          </Stack>

          <Stack
            justifyContent='center'
            paddingTop={1}
            w={{ base: '100%', md: 400 }}
          >
            <Button
              _focusVisible={{ outline: 'none' }}
              type='submit'
              variant={'btn-quilmes'}
            >
              Actualizar contraseña
            </Button>
          </Stack>
          <Box
            alignItems={'flex-start'}
            padding={'1rem 0rem 0rem 0rem'}
            w={{ base: '100%', md: 400 }}
          >
            <Text fontSize={'14px'} fontWeight={'700'}>
              La contraseña debe tener:
            </Text>

            <List padding={'1rem 0rem 0rem 0rem'} spacing={2}>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.length
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Entre 8 y 20 caracteres.
                </Text>
              </ListItem>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.lowercase
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Una minúscula.
                </Text>
              </ListItem>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.uppercase
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Una mayúscula.
                </Text>
              </ListItem>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.number
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Un número.
                </Text>
              </ListItem>
            </List>
          </Box>
        </VStack>

      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default PasswordRecovery
